import React from "react"
import { SpacingProps } from "@material-ui/system"
import MuiDivider, { DividerProps } from "@material-ui/core/Divider"
import Box from "@material-ui/core/Box"

interface IDividerProps extends DividerProps, SpacingProps {
  component?: React.ElementType
  spacing?: number
}

export const Divider: React.FC<IDividerProps> = ({
  orientation = "horizontal",
  variant,
  component = "hr",
  absolute,
  flexItem,
  light,
  spacing = 3,
  ...spacingProps
}) => {
  const defaultSpacing = orientation === "horizontal" ? { my: spacing } : { mx: spacing }

  return (
    <Box {...defaultSpacing} {...spacingProps}>
      <MuiDivider
        orientation={orientation}
        variant={variant}
        absolute={absolute}
        component={component}
        flexItem={flexItem}
        light={light}
      />
    </Box>
  )
}
